/* eslint-disable @typescript-eslint/no-explicit-any */
import { getWindow } from '@migros/msrc-browser';
var dataLayer = [];
if (getWindow()) {
  // disable eslint rule because if statement checks if window is defined
  // eslint-disable-next-line no-restricted-globals
  dataLayer = window.dataLayer || [];
  // eslint-disable-next-line no-restricted-globals
  window.dataLayer = dataLayer;
}

/**
 * In most cases `Analytics.track(event, data)` should be used instead.
 * Pushes raw analytics data into GTM's dataLayer
 */
export function push(data) {
  if (dataLayer && dataLayer.push) {
    dataLayer.push(data);
  }
}